export default __webpack_public_path__ + "static/media/access.4f740ae1.png";